module.exports = __webpack_public_path__ + "img/icon1.8e337c80.png";